/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type TermGenerationMode = typeof TermGenerationMode[keyof typeof TermGenerationMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TermGenerationMode = {
  Recurrence: 'Recurrence',
  Calendar: 'Calendar',
} as const;
